// 这一行必须在最前面：它在 API 客户端建好之前把 fetch 换成假后端。理由见该文件
import './mocks/dev'

// fast-delivery regression checkout
// comment only, no behavior change

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { AppProviders } from './app/providers'
import { startVersionFreshness } from './app/version-freshness'
import { startNpcThemeSync } from './theme/npc-theme'
import './styles.css'

startNpcThemeSync()
startVersionFreshness()

const container = document.getElementById('root')
if (!container) {
  throw new Error('页面上没有 #root，index.html 被改坏了')
}

createRoot(container).render(
  <StrictMode>
    <AppProviders />
  </StrictMode>,
)
